import Vue from 'vue'
import App from './App'
import api from './api'
import vm from './config/vm'
import utils from './config/utils'
import router from './router'
import store from './store'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

Vue.use(ViewUI);

Vue.prototype.$api = api;
Vue.prototype.$vm = vm;
Vue.prototype.$utils = utils;
Vue.prototype.$bus = new Vue();

const savedRoute = sessionStorage.getItem('currentRoute');
if (savedRoute && savedRoute !== window.location.pathname) {
  router.push(savedRoute);
}
router.beforeEach((to, from, next) => {
    if (to.path.startsWith('/login')) {
        store.commit('setLogout',1);
        next()
    } else {
        let token = store.getters.token
        if (!token) {
            next({
                path: '/login'
            })
        } else {
            sessionStorage.setItem('currentRoute', to.fullPath);
            sessionStorage.setItem('currentRouteName', to.name);
            sessionStorage.setItem('fromRoute', from.fullPath);
            next()
        }
    }
});

Vue.config.productionTip = false

new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js